import React, { useEffect } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import { Table, TableBody, TableCell, TableRow, TextField, withStyles } from '@material-ui/core';
import AdminTopbar from './AdminTopbar';
import AdminFooter from './AdminFooter';
import axiosInstance, { WEB_API } from '../common/Constants';
import Button from '@material-ui/core/Button';
import swal from '@sweetalert/with-react';
const styles = (theme) => ({
  root: {
    minHeight: 800,
    '& th': {
      textAlign: 'center',
      fontWeight: 'bold',
      color: theme.palette.primary.main,
    },
  },
});

class DashboardPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      isEdit: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    axiosInstance.get(`${WEB_API}/home/client/innon`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      this.setState({ data: response.data.Item });
    });
  }

  handleChange(type, value) {
    let newData = this.state.data;
    newData[type] = value;

    this.setState({ data: newData });
  }

  handleSubmit() {
    console.log(this.state.data);
    swal({
      title: '해당내용으로 수정하시겠습니까?',
      text: '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axiosInstance.put(`${WEB_API}/home/client/innon`, this.state.data).then((data) => {
          if (data.data.Attributes) {
            this.setState({ data: data.data.Attributes, isEdit: false });
          }
        });
      }
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <Grid item xs={12}>
        <CssBaseline />
        <AdminTopbar MIdx={0} SIdx={0} />
        <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
          <Grid item xs={8}>
            <Grid container alignItems={'center'} justify={'center'} spacing={3}>
              <Grid item xs={8}>
                <h1>Info</h1>
              </Grid>
              <Grid item xs={8}>
                {this.state.data && (
                  <Table className={classes.table}>
                    <TableBody>
                      <TableRow>
                        <TableCell component={'th'}>상호</TableCell>
                        <TableCell>
                          {this.state.isEdit ? (
                            <TextField
                              variant={'outlined'}
                              fullWidth
                              value={this.state.data.title}
                              onChange={(e) => this.handleChange('title', e.target.value)}
                            />
                          ) : (
                            this.state.data.title
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'}>주소</TableCell>
                        <TableCell>
                          {this.state.isEdit ? (
                            <TextField
                              variant={'outlined'}
                              fullWidth
                              value={this.state.data.addr}
                              onChange={(e) => this.handleChange('addr', e.target.value)}
                            />
                          ) : (
                            this.state.data.addr
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'}>주소(영문)</TableCell>
                        <TableCell>
                          {this.state.isEdit ? (
                            <TextField
                              variant={'outlined'}
                              fullWidth
                              value={this.state.data.addrEn}
                              onChange={(e) => this.handleChange('addrEn', e.target.value)}
                            />
                          ) : (
                            this.state.data.addrEn
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'}>Tel</TableCell>
                        <TableCell>
                          {this.state.isEdit ? (
                            <TextField
                              variant={'outlined'}
                              fullWidth
                              value={this.state.data.tel}
                              onChange={(e) => this.handleChange('tel', e.target.value)}
                            />
                          ) : (
                            this.state.data.tel
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'}>Fax</TableCell>
                        <TableCell>
                          {this.state.isEdit ? (
                            <TextField
                              variant={'outlined'}
                              fullWidth
                              value={this.state.data.fax}
                              onChange={(e) => this.handleChange('fax', e.target.value)}
                            />
                          ) : (
                            this.state.data.fax
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'}>Email</TableCell>
                        <TableCell>
                          {this.state.isEdit ? (
                            <TextField
                              variant={'outlined'}
                              fullWidth
                              value={this.state.data.email}
                              onChange={(e) => this.handleChange('email', e.target.value)}
                            />
                          ) : (
                            this.state.data.email
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                )}
              </Grid>
              <Grid item xs={8}>
                <Grid container justify={'space-between'}>
                  {!this.state.isEdit && (
                    <Button variant={'outlined'} color={'secondary'} disableElevation onClick={() => this.setState({ isEdit: true })}>
                      수정하기
                    </Button>
                  )}
                  <Grid item style={{ flex: 1 }}>
                    &nbsp;
                  </Grid>
                  {this.state.isEdit && (
                    <Grid item>
                      <Button
                        variant={'contained'}
                        color={'secondary'}
                        disableElevation
                        onClick={this.handleSubmit}
                        style={{ marginRight: 10 }}
                      >
                        저장하기
                      </Button>
                      <Button variant={'contained'} disableElevation onClick={() => this.setState({ isEdit: false })}>
                        취소
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <AdminFooter />
      </Grid>
    );
  }
}

export default withStyles(styles, { withTheme: true })(DashboardPage);
